export const canadaQuebecEnterpriseNumberProps = {
  placeholder: "1234 567 890",
  mask: "9999 999 999",
  unmask: true,
  fsExclude: true
};
